<template>
    <footer class="footer has-cards">

        <div class="container">
           
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a rel="noopener">Daniel Lopa</a><br><br>
                        <a target="_blank" href="https://www.facebook.com/myvisuals/"><i>Credit photo : Raouf</i></a>
                    </div>
                </div>

            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
